import React from 'react';
import { IonButton, IonCard, IonCol, IonGrid, IonIcon, IonInput, IonItem, IonItemDivider, IonItemGroup, IonLabel, IonModal, IonRow, IonSearchbar, IonText, IonToolbar, isPlatform } from "@ionic/react";
import '../../components/GoogleMap.scss'
import Api from '../../services/Api';
import { CONFIG } from '../../constants'
import { arrowForward } from 'ionicons/icons';

declare var google: any;

interface ErrorInterface  {
  status: boolean,
  message: string,
  title: boolean,
  map: boolean,
  start: boolean,
  type: boolean
}

interface ComponentProps {
  lat: number,
  lng: number,
  zoom: number,
  height: number;
  placeName: string | null | undefined,
  fixedMarker: boolean;
  saveMap?: Function,
  closeModal?: Function
  error?: ErrorInterface
  setError: React.Dispatch<React.SetStateAction<ErrorInterface>>
  create: boolean
  setCreate: React.Dispatch<React.SetStateAction<boolean>>
  handleLatLng: Function
  handleTextInput: Function
  handlePlaceInput: Function
  cancelCreate: Function
}

interface ComponentState {
  placeName: string | undefined | null;
  search: string | undefined
  // movedMap: boolean;
  // disabled: boolean;
  lat: number | undefined,
  lng: number | undefined,
  searchStatus: boolean
  markerset: boolean
  address: string
}

export default class GoogleMap extends React.Component<ComponentProps, ComponentState>  {
  api = Api.getInstance();

  private readonly mapRef: any;
  private map: any;
  private markerPlaced: boolean
  private mark: any

  constructor(props: ComponentProps) {
    super(props);
    this.mapRef = React.createRef();
    this.markerPlaced = false
    this.state = {
      placeName: '',
      search: '',
      lat: 59.3,
      lng: 17.93,
      searchStatus: false,
      markerset: false,
      address: ''
    }
  }

  componentDidMount() {
    this.setState({...this.state, placeName: this.props.placeName})
    if (isPlatform('ios')) {
      setTimeout(() => {
        this.loadMap();
      }, 200);
    } else {
      this.loadMap();
    }
  }

  

  convertLatLng = (lat: number, lng: number) => {
    return new google.maps.LatLng(lat, lng)
  }

  loadMap = () => {
    const latLng = new google.maps.LatLng(this.props.lat, this.props.lng);
    const mapOptions = {
      center: latLng,
      zoom: this.props.zoom,
      mapTypeControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      fullscreenControl: false,
      clickableIcons: false,
      streetViewControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER,
      }
    };

    this.map = new google.maps.Map(this.mapRef.current, mapOptions);

    if(latLng && this.props.lat !== 59.3) {
      this.placeMarkerAndPanTo(latLng, this.map);
    }

    this.map.addListener("click", (e: any) => {
      this.placeMarkerAndPanTo(e.latLng, this.map);
      this.setState({ ...this.state, markerset: true })
    });
  }

  private placeMarkerAndPanTo = (latLng: any, map: any) => {
    if(this.markerPlaced === false) {
      this.mark = new google.maps.Marker({
        position: latLng,
        map: map,
      });

      this.markerPlaced = true
    } else {
      this.mark.setPosition(latLng)
    }
    map.panTo(latLng);
    this.getMarkerAddress(latLng.lat(), latLng.lng())
    this.props.handleLatLng(latLng.lat(), latLng.lng())
  }

  getMarkerAddress = (lat: number , lng: number ) => {
    fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${CONFIG.GOOGLE_KEY}`).then(res => res.json()).then(data => {
      if(data.status === 'OK') {
        this.setState({...this.state, address: data.results[0].formatted_address})
      } else {
        this.setState({...this.state, address: 'Kunde inte hitta addressen'})
      }
    })
  }

  // private handlePlaceName = (event: any) => {
  //   const placeName = event.target.value;
  //   const disabled = placeName.length > 2 ? false : true;
  //   this.setState({
  //     ...this.state,
  //     placeName: placeName, 
  //     disabled: disabled
  //   });
  // }

  private closeModal = () => {
    if (this.props.closeModal) {
      this.props.closeModal();
      this.props.handlePlaceInput(this.state.placeName)
    }
  }

  saveMap = () => {
    if (this.props.saveMap) {
      const zoom = this.map.zoom;
      const lat = this.map.center.lat();
      const lng = this.map.center.lng();
      this.props.saveMap(lat, lng, zoom, this.state.placeName);
    }
  }

  searchGoogle = () => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${this.state.search}&key=${CONFIG.GOOGLE_KEY}`

    fetch(url).then(res => res.json()).then(data => {
      if(data.status === 'OK') {
        this.setState({
          ...this.state,
          lat: data.results[0].geometry.location.lat,
          lng: data.results[0].geometry.location.lng,
          searchStatus: true,
          markerset: true,
          address: data.results[0].formatted_address
        })
        this.placeMarkerAndPanTo(this.convertLatLng(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng), this.map);  
      } else {
        this.setState({
          ...this.state,
          searchStatus: false
        })
        if(data.status === 'ZERO_RESULTS') {
          // this.props.setError({...error, status: true, message: 'Kunde inte hitta platsen' })
        } else {
          // this.props.setError({ status: true, message: 'Någonting gick fel' })
        }
      }
    })
  }

  createStarted = () => {
    this.props.setCreate(false)
  }

  componentWillUnmount() {
    // this.props.handlePlaceInput(this.state.placeName)
  }

  render() {
    const height = window.innerHeight - 250
    return (
      <IonGrid className="fullWidth" onClick={() => {
        this.createStarted()
      }}>
        <h2 className="color_blue text_center my-4">{this.api.tr('Map_spot_pick')}</h2>
          <IonToolbar>
            <IonItem lines="none">
              <IonSearchbar 
                color="light"
                type="text"
                mode="ios"
                className="p-0"
                value={this.state.search} 
                onClick={() => {
                  this.createStarted()
                  // this.props.setError({status: false, message: ''})
                }}
                onIonChange={e => this.setState({
                  ...this.state,
                  search: e.detail.value
                })}/>
                <IonButton 
                  className="ml-2"
                  slot="end"
                  size="small" 
                  onClick={() => {
                    if(this.state.search !== "") {
                      this.searchGoogle()
                    } else {
                      // this.props.setError({ status: true, message: 'Sökfältet kan inte vara tomt' })
                    }
                  }}>
                    {this.api.tr('Search_field')}
                  </IonButton>
              </IonItem>
              <IonRow>
                <IonText className="font_italic color_grey font_small mx-4 mb-2">
                  Search with a place or address. E.g. 'Södermalm', 'Götgatan, Stockholm'. Or use the map to navigate.
                </IonText>
              </IonRow>
              <IonRow className="mb-2">
                <IonCol>
                  <IonText>
                    { this.props.error && this.props.error.status ? <IonText>{this.props.error.message}</IonText> : null }
                  </IonText>
                </IonCol>
              </IonRow>
          </IonToolbar>
        { this.props.create && !this.markerPlaced ? 
          <IonRow className="google_start">
            <IonText className="google_start_message">
            {this.api.tr('mappopup_description')}
            </IonText>
          </IonRow>
        : null }
        <div 
          ref={this.mapRef} 
          style={{ height: height + "px"}}>
        </div>
        <IonModal
          class="sheetModal p-2"
          breakpoints={[0.1, 0.4, 1]}
          initialBreakpoint={0.4}
          isOpen={this.state.markerset}
          onDidDismiss={() => {
            this.setState({...this.state, markerset: false})
          }}>
            <IonItemGroup>
              <IonItemDivider class="p-2" color="darkblue">
                <IonLabel>{this.api.tr('mapselectioncard_meet')}</IonLabel>
              </IonItemDivider>
              <IonItem color="light" lines="none">
                <IonText className="p-2">
                  {this.state.address}
                </IonText>
              </IonItem>
              <IonItemDivider class="p-2" color="darkblue">
                <IonLabel>{this.api.tr('mapselectioncard_description')}</IonLabel>
              </IonItemDivider>
              <IonCard className="m-2 p-2">
                <IonItem lines="none">
                  <IonInput 
                    id="place_name" 
                    type="text" 
                    value={this.state.placeName} 
                    placeholder={this.api.tr('mapselectioncard_detail')}
                    onIonChange={(e) => this.setState({...this.state, placeName: e.detail.value })}/>
                </IonItem>
              </IonCard>
            </IonItemGroup>
            <IonButton className="m-2" onClick={() => {
              this.setState({...this.state, markerset: false}, () => this.closeModal())
              }}>
              {this.api.tr('Select_locationContinue')}
              <IonIcon icon={arrowForward} className="ml-2"/>
            </IonButton>
            <IonButton 
              className="m-2" 
              color="danger" 
              fill="clear"
              onClick={() => {
                this.setState({...this.state, markerset: false})
                this.props.cancelCreate()
              }}>
              {this.api.tr('cancel')}
            </IonButton>
        </IonModal>
        { this.markerPlaced ? 
        <IonGrid className="google_done_button button_shadow">
          <IonItemDivider color="darkblue" className="p-2">
            <IonLabel>
            {this.api.tr('Add_description_location')}
            </IonLabel>
          </IonItemDivider>
          <IonInput 
            className="m-2" 
            id="place_name" 
            type="text" 
            value={this.state.placeName} 
            placeholder={this.api.tr('Describe_location')}
            onIonChange={(e) => this.setState({...this.state, placeName: e.detail.value })}/>
          <IonButton className="m-2" expand="block" onClick={() => {
            this.setState({...this.state, markerset: false}, () => this.closeModal())
            
            }}>
            {this.api.tr('Select_locationContinue')}
            <IonIcon icon={arrowForward} className="ml-2"/>
          </IonButton>
        </IonGrid> : null }
      </IonGrid>
    )
  }
}
